export default 960;